<template>
  <div>
    <button
      :ref="`filter-button-${uid}`"
      :class="`${isClicked ? 'bg-main-primary text-white ' : ''} flex h-min items-center gap-x-2 whitespace-nowrap rounded-full bg-[#E9F3F2] px-4 py-2 text-[#218579]`"
      @click="handleClick"
    >
      <span>{{ truncateFileName(file) }}</span>
      <span
        type="button"
        class="p-0 text-md"
        @click.stop="showDocumentDropDown = !showDocumentDropDown"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
          />
        </svg>
      </span>
      <div
        v-if="showDocumentDropDown"
        class="flex gap-1"
      >
        <div
          :ref="`button-action-${uid}`"
          class="relative z-20"
        >
          <div class="absolute left-0 top-[105%] z-[60] text-main-primary">
            <div class="px-6 py-3 text-left bg-white rounded-lg shadow-md">
              <div class="relative max-h-[250px] overflow-y-auto">
                <div class="flex flex-col items-start gap-y-2">
                  <button
                    v-if="isClicked"
                    class="text-md whitespace-nowrap"
                    @click.stop="
                      removeFilter();
                      showDocumentDropDown = false;
                    "
                  >
                    Remove Filter
                  </button>
                  <button
                    v-if="canAttach"
                    class="text-md whitespace-nowrap"
                    @click.stop="
                      handleFileAttachment();
                      showDocumentDropDown = false;
                    "
                  >
                    Attach to selected
                  </button>
                  <button
                    v-if="canUnlink"
                    class="text-md whitespace-nowrap"
                    @click.stop="
                      unlinkDocument();
                      showDocumentDropDown = false;
                    "
                  >
                    Unlink
                  </button>
                  <button
                    class="text-md whitespace-nowrap"
                    @click.stop="viewDocument"
                  >
                    View
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </button>
  </div>
</template>

<script>
import AttachmentViewer from '@/components/AttachmentViewer'

export default {
  name: 'FilterDocumentBadge',

  props: {
    file: {
      type: String,
      required: true,
    },
    selectedFile: {
      type: Boolean,
      default: false,
    },
    canUnlink: {
      type: Boolean,
      default: true,
    },
    canAttach: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['badgeClicked', 'attachSelected', 'documentUnlinked'],

  data() {
    return {
      isClicked: this.selectedFile,
      uid: null,
      showDocumentDropDown: false,
    }
  },

  mounted() {
    this.uid = this.$.uid
  },

  methods: {
    handleClick() {
      this.isClicked = !this.isClicked
      this.$emit('badgeClicked', {
        fileName: this.file,
        isClicked: this.isClicked,
      })
    },
    removeFilter() {
      this.isClicked = false
      this.$emit('badgeClicked', { fileName: this.file, isClicked: false })
    },
    handleFileAttachment() {
      this.$emit('attachSelected', this.file)
    },
    unlinkDocument() {
      this.isClicked = false
      this.$emit('documentUnlinked', this.file)
      this.$emit('badgeClicked', { fileName: this.file, isClicked: false })
    },
    truncateFileName(file_name, maxLength = 25) {
      const segments = file_name.split('-')
      const fileName = segments[segments.length - 1]
      if (fileName.length <= maxLength) {
        return fileName
      }
      const extIndex = fileName.lastIndexOf('.')
      const extension = fileName.substring(extIndex)
      const nameWithoutExtension = fileName.substring(0, extIndex)
      const truncatedLength = maxLength - extension.length - 3
      const truncatedName
        = nameWithoutExtension.substring(0, truncatedLength) + '...'
      return truncatedName + extension
    },
    viewDocument() {
      this.showDocumentDropDown = false
      this.$modal.show(
        AttachmentViewer,
        { fileName: this.file },
        { adaptive: true, maxHeight: window.innerHeight - 100, shiftY: 0.1 },
      )
    },
  },
}
</script>
